import React from "react";
import Content6 from "./content6";
import PickupDrop from "./pickupDrop";
import MotoDoctorHero from "./motoServices";
import { Helmet } from "react-helmet-async";

function Services() {
  return (
    <>
      <Helmet>
        {/* TITLE */}
        <title>Bike Support Services in Chennai | MotoDoctor On-Demand Help</title>

        {/* META DESCRIPTION */}
        <meta
          name="description"
          content="Explore MotoDoctor’s complete range of bike support services in Chennai, including quick issue diagnosis, emergency assistance, skilled technician help, and app-based service booking for stress-free rides."
        />

        {/* CANONICAL */}
        <link rel="canonical" href="https://motodoctor.in/services" />

        {/* H1 (as meta) */}
        <meta name="heading" content="Emergency Roadside Assistance" />

        {/* H2 (as meta) */}
        <meta name="subheadings" content="MotoDoctor Pickup and Drop Service, All other subheading" />

        {/* SCHEMA – SERVICE PAGE */}
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "MotoDoctor Bike Support Services",
  "url": "https://motodoctor.in/services",
  "description": "MotoDoctor offers a full range of bike support solutions in Chennai, including issue diagnosis, emergency assistance, skilled technician help, and app-based service booking for a smooth riding experience.",
  "provider": {
    "@type": "Organization",
    "name": "MotoDoctor",
    "url": "https://www.motodoctor.in",
    "logo": "https://www.motodoctor.in/static/media/Moto-Doc-Logo.dae1a58c6b5b5e7d510d8c23a099beff.svg"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Chennai",
      "addressRegion": "Tamil Nadu",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Motorcycle issue diagnosis",
    "Emergency roadside help",
    "Skilled mechanic assistance",
    "Towing support",
    "App-based service booking"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "MotoDoctor Service Catalog",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Breakdown assistance"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "On-site technician support"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Bike towing service"
        }
      }
    ]
  }
}
    `}
        </script>
      </Helmet>

      <div>
        <Content6 />
        <PickupDrop />
        <MotoDoctorHero />
      </div>
    </>
  );
}

export default Services;
